import { render, staticRenderFns } from "./ErrorData.vue?vue&type=template&id=1d2fe64c&scoped=true&"
import script from "./ErrorData.vue?vue&type=script&lang=js&"
export * from "./ErrorData.vue?vue&type=script&lang=js&"
import style0 from "./ErrorData.vue?vue&type=style&index=0&id=1d2fe64c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2fe64c",
  null
  
)

export default component.exports